import React, { useState, useEffect } from 'react';
import styles from "./GlobalLoader.module.scss"
import { useSelector } from 'react-redux';
import { useRouter } from 'next/compat/router';
 
const GlobalLoader = () => {
  const router = useRouter();

  //  this code is checking if the page has finished loading after the component mounts.
  //  this code is used to fix the CLS issue for Home page
  

  return (
    <>
      {/* check the loading state and homepage */}
      <div className={styles.loader_container}>
        <div className={styles.loader}></div>
      </div>
    </>
  );
};

export default GlobalLoader;